module.exports = __webpack_public_path__ + "static/media/BottomIcon3.5d674eb7.png";